import { z } from 'zod';

export const cvUploadResponseSchema = z.object({
    id: z.string(),
});

export type CvUploadResponse = z.infer<typeof cvUploadResponseSchema>;

const itemSchema = z.object({
    language: z.string(),
    text: z.string().optional().nullable(),
});

export type CompanyProfileItem = z.infer<typeof itemSchema>;

export const companyProfileSchema = z.object({
    description: itemSchema.array().optional().nullable(),
    name: z.string(),
    priorities: itemSchema.array().optional().nullable(),
});

export type CompanyProfile = z.infer<typeof companyProfileSchema>;
